import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import new_user_imp_central_carousel_template from '@/../templates/new-user-imp-central-carousel-layout.hbs';

    var globalCh = Radio.channel('global');
    export default function show_new_user_imp_central_carousel() {
        var NewUserImpCentralCarousel = Marionette.View.extend(DialogInterface).extend({
            template: Handlebars.compile(new_user_imp_central_carousel_template),
            initialize: function () {
                this.destroyOnClose();
            },
            ui: {
                'create': '.btn.create',
            },
            events: {
                'click @ui.create': function(e){
                    e.preventDefault();
                    globalCh.request('showCreateProductDialog');
                },
            }
        });
        globalCh.request('showDialog', new NewUserImpCentralCarousel());
    }

